import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "asvasa_customer_token";

export const customerApi = axios.create({ baseURL: API });
customerApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const setCustomerToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const getCustomerToken = () => localStorage.getItem(TOKEN_KEY);
export const clearCustomerToken = () => localStorage.removeItem(TOKEN_KEY);

export const register = (payload) =>
  customerApi.post("/customer/register", payload).then((r) => r.data);

export const login = (email, password) =>
  customerApi.post("/customer/login", { email, password }).then((r) => r.data);

export const exchangeGoogleSession = (sessionId) =>
  customerApi.post("/customer/google/session", { session_id: sessionId }).then((r) => r.data);

export const fetchMe = () => customerApi.get("/customer/me").then((r) => r.data);
export const updateMe = (payload) => customerApi.put("/customer/me", payload).then((r) => r.data);

export const getWishlist = () => customerApi.get("/customer/wishlist").then((r) => r.data);
export const addToWishlist = (slug) =>
  customerApi.post("/customer/wishlist", { slug }).then((r) => r.data);
export const removeFromWishlist = (slug) =>
  customerApi.delete(`/customer/wishlist/${slug}`).then((r) => r.data);

export const placeOrderAsCustomer = (payload) =>
  customerApi.post("/customer/orders", payload).then((r) => r.data);
export const placeOrderAsGuest = (payload) =>
  customerApi.post("/orders", payload).then((r) => r.data);
export const listMyOrders = () =>
  customerApi.get("/customer/orders").then((r) => r.data);
export const getMyOrder = (orderId) =>
  customerApi.get(`/customer/orders/${orderId}`).then((r) => r.data);
export const guestOrderLookup = (orderNumber, email) =>
  customerApi
    .get(`/orders/lookup?order_number=${encodeURIComponent(orderNumber)}&email=${encodeURIComponent(email)}`)
    .then((r) => r.data);

// ---------- Razorpay ----------
export const createRazorpayOrder = (payload) =>
  customerApi.post("/payments/razorpay/order", payload).then((r) => r.data);

export const verifyRazorpayPayment = (payload) =>
  customerApi.post("/payments/razorpay/verify", payload).then((r) => r.data);

// ---------- Shipping (public) ----------
export const checkServiceability = (pincode, cod = false, weight = 0.5) =>
  customerApi
    .get(`/shipping/serviceability?pincode=${encodeURIComponent(pincode)}&cod=${cod}&weight=${weight}`)
    .then((r) => r.data);

// ---------- Reviews ----------
export const postCustomerReview = (payload) =>
  customerApi.post("/customer/reviews", payload).then((r) => r.data);

export const listAddresses = () => customerApi.get("/customer/addresses").then((r) => r.data);
export const addAddress = (payload) => customerApi.post("/customer/addresses", payload).then((r) => r.data);
export const updateAddress = (id, payload) =>
  customerApi.put(`/customer/addresses/${id}`, payload).then((r) => r.data);
export const removeAddress = (id) =>
  customerApi.delete(`/customer/addresses/${id}`).then((r) => r.data);
export const setDefaultAddress = (id) =>
  customerApi.post(`/customer/addresses/${id}/default`).then((r) => r.data);

export const formatApiError = (err, fallback = "Something went wrong") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
};
